<template>
  <card-collapsable
    :headerClass="headerClass"
    dialogClass="bustachiusa"
    :dialogProp="dialog"
    @changeCollapse="changeCollapse"
  >
    <!-- :collapsed="collapsed" -->
    <!-- always visible -->
    <template #visible>
      <progress-countdown
        v-if="asta_settings.timeout_s && calciatoreInAsta && !offerto && active"
        ref="timer_bustachiusa"
        :time="asta_settings.timeout_s"
        @timeover="timeoverBustaChiusa"
        name="bustachiusa"
      ></progress-countdown>
      <v-icon v-if="collapsed && passato">airline_stops</v-icon>
      <squadra-offerta
        v-else-if="collapsed && offerto"
        :offerta="miaOfferta"
        :label="''"
        :uid="user_uid"
      ></squadra-offerta>
    </template>

    <!-- card-title -->
    <template #title>
      {{
        offerteCompletate
          ? "Tutti hanno inviato la busta"
          : !active && admin
          ? "Attendi tutte le offerte"
          : "Fai offerta"
      }}
    </template>

    <!-- card-body -->
    <template #body>
      <calciatore-battuto
        :id="calciatoreInAsta"
        v-if="calciatoreInAsta"
        xLarge
      ></calciatore-battuto>

      <!-- 1) Buste da aprire/aperte -->
      <div v-if="roundStep && roundStep.type == Constants.ROUND_STEP.BUSTE">
        <v-list class="lista_buste">
          <!-- lista offerte -->
          <v-list-item v-for="off in offerte" :key="off.s">
            <v-list-item-avatar>
              <img :src="squadra(off.s).pic" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title
                v-text="squadra(off.s).name"
              ></v-list-item-title>
              <div v-if="off.o > Constants.OFFERTA.PASSO">
                <v-icon color="text" x-small>schedule</v-icon>
                <small><span v-html="offertaTime(off.s)"></span></small>
              </div>
              <div v-else>
                <small>Nessuna offerta</small>
              </div>
            </v-list-item-content>

            <v-list-item-action>
              <!-- vincente -->
              <v-badge
                left
                color="secondary"
                content="Top"
                offset-x="10"
                offset-y="10"
                v-if="
                  off.o == migliore_offerta.offerta &&
                  off.o !== Constants.OFFERTA.PASSO
                "
              >
                <span class="offerta">{{ off.o }}</span>
              </v-badge>
              <!-- passo -->
              <span v-else-if="off.o == Constants.OFFERTA.PASSO"></span>
              <!-- default -->
              <span class="offerta" v-else>{{ off.o }}</span>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <!-- Esito buste -->
        <div class="text-center" v-if="offerteCompletate">
          <v-divider></v-divider>
          <div class="ma-4 text-body-1">
            <span v-html="esito_buste"></span>
          </div>
          <v-btn
            depressed
            class="mb-4"
            color="primary"
            rounded
            v-if="admin"
            :loading="loading"
            @click="esito"
            >Avanti</v-btn
          >
        </div>
      </div>

      <!-- Durante Collezione Offerte -->
      <div v-else class="text-center">
        <div v-if="active">
          <!-- 1a) Collezione Offerte (io): se non ho offerto o passato -->
          <div
            v-if="!offerto && !passato"
            class="d-flex justify-center align-center ma-4"
          >
            <v-btn
              depressed
              color="primary"
              rounded
              id="numpad-btn"
              @click="showNumpad"
            >
              Offerta
            </v-btn>
            <v-btn
              color="primary"
              text
              rounded
              v-if="roundStep && !roundStep.min_offerta"
              @click="setPasso(true)"
            >
              Passo
            </v-btn>
          </div>

          <!-- 1b) Collezione Offerte (io): nn posso offrire perchè ruolo è complato -->
          <div v-else-if="ruoloCalciatoreInAstaCompletato" class="ma-4">
            <v-chip outlined color="error"> Ruolo completato </v-chip>
          </div>

          <!-- 1c) Collezione Offerte (io): se ho passato -->
          <div v-else-if="passato" class="ma-4">
            <div class="error--text text-button">
              <v-icon left class="error--text">airline_stops</v-icon>
              Hai passato
            </div>
          </div>

          <!-- 1d) Collezione Offerte (io): se ho offerto -->
          <div v-else-if="offerto">
            <squadra-offerta
              :offerta="miaOfferta"
              :label="'La mia offerta'"
              :uid="user_uid"
            ></squadra-offerta>
          </div>
        </div>

        <!-- 2a) Collezione Offerte (tutti): se Tutti hanno inviato la busta -->
        <div v-if="offerteCompletate" class="ma-4">
          <v-btn color="primary" rounded large v-if="admin" @click="apriBuste"
            >Apri buste</v-btn
          >
          <div v-else>
            <div class="text-body-2">
              <v-progress-circular
                indeterminate
                :size="15"
                :width="2"
              ></v-progress-circular>
              In attesa che l'admin apra le buste...
            </div>
          </div>
        </div>

        <!-- 2b) Collezione Offerte (tutti): Se io ho offerto ma qualcun altro no -->
        <div
          v-else-if="(offerto && !offerteCompletate) || (admin && !active)"
          class="pa-2"
        >
          <div class="text-body-2">
            <v-progress-circular
              indeterminate
              :size="15"
              :width="2"
            ></v-progress-circular>
            In attesa degli altri partecipanti...
          </div>
        </div>
      </div>
    </template>

    <!-- footer -->
    <template #actions>
      <div v-if="squadra(user_uid) && !offerto && active" class="pa-4">
        <squadra-info-panel :id_squadra="user_uid"></squadra-info-panel>
      </div>
      <div v-if="my_squadra" class="px-4 pb-4">
        <v-list
          :class="{ 'nice-scroll': !is_mobile }"
          class="recycle-scroller navy darken-1 pb-2 rounded"
        >
          <div class="text-center py-2">Pianificazione</div>
          <asta-consiglio></asta-consiglio>
          <asta-slot
            v-for="(slotData, slot, i) in myPlan[ruolo_abc]"
            :key="ruolo_abc + '_' + slot"
            :ruolo_abc="ruolo_abc"
            :iSlot="slot"
            :i="i"
          ></asta-slot>
        </v-list>
      </div>
    </template>
  </card-collapsable>
</template>

<script>
import db from "../../js/db";
import Vuex from "vuex";
import moment from "moment";
import Constants from "../../js/constants";
import mixins from "../../js/mixins";

import toast from "../../js/toast";
import ProgressCountdown from "../common/ProgressCountdown";
import SquadraInfoPanel from "../common/SquadraInfoPanel";
import CalciatoreBattuto from "../common/CalciatoreBattuto";
import CardCollapsable from "../common/CardCollapsable";
import SquadraOfferta from "../common/SquadraOfferta";
import AstaSlot from "../AstaSlot";
import AstaConsiglio from "../AstaConsiglio";

import * as Helpers from "../../js/helpers";

export default {
  name: "asta-busta-chiusa",
  mixins: [mixins, toast],
  components: {
    ProgressCountdown,
    SquadraInfoPanel,
    CalciatoreBattuto,
    CardCollapsable,
    SquadraOfferta,
    AstaSlot,
    AstaConsiglio
  },
  data() {
    return {
      resetT: false,
      timeover: true,
      step: 1,
      esito_buste: "",
      esito_cb: () => {},
      collapsed: false,
      loading: false,
    };
  },
  mounted() {
    console.log("--> AstaBustaChiusa ready.");
    // Start / Stop timer in funzione dello stato dell'asta
    db.on("status", this.onStatusChange);
    db.on("numpadSubmitted", this.inviaBusta);
  },
  destroyed() {
    console.log("<-- AstaBustaChiusa destroyed.");
    db.off("status", this.onStatusChange);
    db.off("numpadSubmitted", this.inviaBusta);
  },
  methods: {
    async esito() {
      this.loading = true;
      await this.wait(1000); // altrimenti il loader nn si vede
      await this.esito_cb();
      this.loading = false;
    },
    onStatusChange(status) {
      //if (this.mode_bustachiusa && this.calciatoreInAsta !== null) {
      // if (this.is_calciatore_in_asta) {
      switch (status) {
        case Constants.ASTA_STATUS.NOT_RUNNING:
          this.stopTimer();
          break;
        case Constants.ASTA_STATUS.RUNNING:
          if (
            this.roundStep &&
            this.roundStep.type === Constants.ROUND_STEP.OFFERTE
          ) {
            this.startTimer();
          } else if (
            this.roundStep &&
            this.roundStep.type === Constants.ROUND_STEP.BUSTE
          ) {
            this.esaminaBuste();
          }
          break;
      }
      // }
    },
    changeCollapse(val) {
      this.collapsed = val;
    },

    inviaBusta(offerta) {
      db.setOfferta(
        offerta,
        false,
        true,
        offerta !== this.roundStep.min_offerta
      );
      this.stopTimer();

      // Swal.fire({
      //   title: "Confermi offerta di " + offerta + "?",
      //   text: "Non potrai annullare l'operazione",
      //   icon: "warning",
      //   showCancelButton: true,
      //   confirmButtonText: "Invia Busta",
      //   cancelButtonText: "Annulla",
      // }).then((result) => {
      //   if (result.isConfirmed == true) {
      //     db.setOfferta(
      //       offerta,
      //       false,
      //       true,
      //       offerta !== this.roundStep.min_offerta
      //     );
      //     this.stopTimer();
      //   }
      // });
    },
    apriBuste() {
      db.setStep({
        type: Constants.ROUND_STEP.BUSTE,
        min_offerta: this.roundStep.min_offerta
          ? this.roundStep.min_offerta
          : null,
      });
    },
    esaminaBuste() {
      let offertaVincente = this.migliore_offerta.offerta;

      // A) TUTTI HANNO PASSATO
      if (this.migliore_offerta.offerta === Constants.OFFERTA.PASSO) {
        this.esito_buste = "Tutti hanno passato. Il calciatore verrà scartato";
        this.esito_cb = () => {
          db.emit("offerte");
        };
        return;
      }

      // B) UN SOLO VINCITORE
      let offerte_vincenti = _.sumBy(_.values(this.asta_round.offerte), (i) =>
        i === offertaVincente ? 1 : 0
      );
      if (offerte_vincenti === 1) {
        this.esito_buste =
          "<b>" +
          this.squadra(this.migliore_offerta.vincitore).name +
          " </b> si è aggiudicato il calciatore.";
        this.esito_cb = () => {
          let offerte = _.cloneDeep(this.asta_round.offerte);
          var offerte_edited = false;
          for (let sqid in offerte) {
            if (
              offerte[sqid] !== offertaVincente &&
              offerte[sqid] !== Constants.OFFERTA.PASSO
            ) {
              offerte[sqid] = Constants.OFFERTA.PASSO;
              offerte_edited = true;
            }
          }
          if (offerte_edited) {
            db.setOfferte(offerte);
          } else {
            db.emit("offerte");
          }
        };
        return;
      }
      // PIU' DI UN VINCITORE
      // SE ALMENO UNO HA RILANCIATO ALLORA AVVIO SECONDO ROUND
      // ALTRIMENTI ASSEGNO A CHI A INVIATO PER PRIMA LA BUSTA
      else if (offerte_vincenti > 1) {
        var new_round = false;
        let offerte = this.asta_round.offerte;

        // Nessun ha rilanciato nel secondo round
        if (this.roundStep.min_offerta === offertaVincente) {
          new_round = false;
        } else {
          for (let sqid in offerte) {
            // VERIFICO SE PUO' RILANCIARE
            if (offerte[sqid] === offertaVincente) {
              if (this.squadra(sqid).max_offerta > offertaVincente)
                new_round = true;
              break;
            }
          }
        }

        if (new_round) {
          this.esito_buste =
            "Più di un vincitore. Si procede con un nuovo round tra i soli vincitori.";
        } else {
          this.esito_buste =
            "Nessuno ha offerto di più: calciatore assegnato a <b>" +
            this.squadra(this.offerte[0].s).name +
            "</b> perché è stato il più rapido a fare l'offerta migliore";
        }

        // NUOVO_ROUND
        this.esito_cb = new_round
          ? () => {
              let offerte = _.cloneDeep(this.asta_round.offerte);
              for (let sqid in offerte) {
                if (offerte[sqid] === offertaVincente) {
                  offerte[sqid] = Constants.OFFERTA.INIT;
                } else {
                  offerte[sqid] = Constants.OFFERTA.PASSO;
                }
              }

              db.setStep({
                type: Constants.ROUND_STEP.OFFERTE,
                min_offerta: offertaVincente,
              }).then(db.setOfferte(offerte));
            }
          : () => {
              let offerte = _.cloneDeep(this.asta_round.offerte);
              for (let sqid in offerte) {
                if (sqid !== this.offerte[0].s) {
                  offerte[sqid] = Constants.OFFERTA.PASSO;
                }
              }
              db.setOfferte(offerte);
            };
      }
    },
    showNumpad() {
      db.emit("numpad", true);
    },
    hideNumpad() {
      db.emit("numpad", false);
    },
    timeoverBustaChiusa() {
      this.timeover = true;
      setTimeout(() => {
        if (
          !this.offerto &&
          this.running &&
          this.squadra(this.user_uid).active
        ) {
          if (this.roundStep.min_offerta) {
            db.setOfferta(this.roundStep.min_offerta, false, true);
          } else {
            this.setPasso();
          }
        }
      }, 2000);
    },
    setPasso(confirm = false) {
      // passo solo se non sono il vincitore (il check serve per evitare di sovrascrivere offerta al timeout)
      if (confirm) {
        Swal.fire({
          title: "Vuoi passare?",
          text: "Non potrai annullare l'operazione",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed == true) {
            db.setOfferta(Constants.OFFERTA.PASSO, false, true);
          }
        });
      } else {
        db.setOfferta(Constants.OFFERTA.PASSO, false, true);
        Swal.close();
      }
    },
    startTimer() {
      this.timeover = false;
      if (this.$refs["timer_bustachiusa"] !== undefined) {
        this.$refs["timer_bustachiusa"].start();
      }
      
      // NECESSARIO PER RITARDARE L'ASSEGNAZIONE DI resetT
      setTimeout(() => {
        this.resetT = true;
      }, 0);
    },
    stopTimer() {
      if (this.$refs["timer_bustachiusa"] !== undefined) {
        this.$refs["timer_bustachiusa"].stop();
      } else {
        // console.log("timer_bustachiusa non è definito");
      }
    },
    offertaTime(uid) {
      return this.asta_round.offerte_ts && uid in this.asta_round.offerte_ts
        ? moment(this.asta_round.offerte_ts[uid]).format("HH:mm:ss") +
            '<span class="offerta_millis">.' +
            moment(this.asta_round.offerte_ts[uid]).format("SSS") +
            "</span>"
        : "";
    },
  },
  watch: {
    roundStep(val) {
      if (this.running) {
        if (val !== null && val.type === Constants.ROUND_STEP.OFFERTE) {
          this.startTimer();
        } else if (val !== null && val.type === Constants.ROUND_STEP.BUSTE) {
          this.stopTimer();
          this.esaminaBuste();
        }
      }
    },
    timeover(val) {
      if (val) {
        this.hideNumpad();
      }
    },
    dialog(val) {
      if (!val) {
        this.hideNumpad();
      } else {
        this.loading = false;
      }
    },
  },
  computed: {
    headerClass() {
      return {
        "yellow darken-2 white--text": !this.offerteCompletate,
        "green white--text": this.offerteCompletate,
      };
    },
    // collapsed() {
    //   return false;
    // },
    roundStep() {
      return this.asta_round.step;
    },
    vincitore() {
      return this.migliore_offerta.vincitore;
    },
    sonoVincitore() {
      return this.miaOfferta === this.migliore_offerta.offerta;
    },
    offerto() {
      return this.miaOfferta !== Constants.OFFERTA.INIT;
    },
    passato() {
      return this.miaOfferta === Constants.OFFERTA.PASSO;
    },
    miaOfferta() {
      return this.asta_round.offerte && this.user_uid in this.asta_round.offerte
        ? this.asta_round.offerte[this.user_uid]
        : Constants.OFFERTA.INIT;
    },
    miaOffertaTime() {
      return this.offertaTime(this.user_uid);
    },
    offerteCompletate() {
      return Helpers.offerteCompletate(this.asta_round.offerte);
    },
    active() {
      return this.squadra(this.user_uid) && this.squadra(this.user_uid).active;
    },
    offerte() {
      return _.orderBy(
        _.map(this.asta_round.offerte, (value, key) => {
          return {
            s: key,
            o: value,
            ts:
              key in this.asta_round.offerte_ts
                ? this.asta_round.offerte_ts[key]
                : -1,
          };
        }),
        ["o", "ts"],
        ["desc", "asc"]
      );
    },
    dialog() {
      return Boolean(
        (this.active || this.admin) &&
          this.calciatoreInAsta !== null &&
          this.calciatoreInAsta !== undefined &&
          this.running
      );
    },
    ruolo_abc() {
      if (this.calciatoreInAsta != null) {
        return Constants.RUOLI_NEW[
          this.calciatori[this.calciatoreInAsta].ID_Ruolo
        ].abc;
      }
      return null;
    },
    ...Vuex.mapGetters(["migliore_offerta", "myPlan"]),
  },
};
</script>
<style>
.lista_buste {
  max-height: 205px;
  overflow: auto;
}
.offerta {
  min-width: 30px;
  width: 30px;
  height: 30px;
}
.offerta_millis {
  color: rgba(0, 0, 0, 0.34);
}
</style>
